import AppLoader from './Loader';
import ErrorLabel from './ErrorLabel';
import DeleteModal from './DeleteModal';
import AppPagination from './Pagination';

export default {
	AppLoader,
	ErrorLabel,
	DeleteModal,
	AppPagination,
}


// WEBPACK FOOTER //
// ./src/components/partials/index.js